import React from 'react';
import {getLabel} from "../../language";
import {Link} from "react-router-dom";
import Avatar from "../../images/avatar.svg";
import VoteItem from "../Utils/VoteItem";
import moment from "moment";
import {createPartiesVote, fetchAveragesVotesList, fetchPartyVotesList} from "../../actions/votes";
import {addPartyComments, fetchPartyCommentList, fetchRelatedParty} from '../../actions/pollypage';
import {connect} from "react-redux";
import PrivacyModal from "../Utils/PrivacyModal";
import agent from "../../agent";
import PostAvatar from "../Post/PostAvatar";
import SharePostModal from "./SharePostModal";
import Slider from "react-rangeslider";
import up_vote from "../../images/up_1.svg";
import undecided_vote from "../../images/maybe_1.svg";
import down_vote from "../../images/down_1.svg";
import {Modal} from "react-bootstrap";
import UserModal from "../AuthModal";
import VoterLocationsTab from "../Settings/VoterLocationsTab";
import {ABUSE, COMMENT_MAX_CHARACTER} from "../../constants/actionTypes";
import {message, Modal as antdModel, Popconfirm} from "antd";
import {Helmet} from "react-helmet";

const mapStateToProps = state => ({
    ...state.common,
    currentUser: state.common.currentUser,
    averagesVotes: state.votes.averagesVotes,
    partiesVotes: state.votes.partiesVotes,
    partiesVotesError: state.votes.partiesVotesError,
    partiesVote: state.votes.partiesVote,
    relatedPartyList: state.polly.relatedPartyList,
    partyCommentsList: state.polly.partyCommentsList,
    userInfo: state.polly && state.polly.userInfo,
    isAuthorized: state.auth && state.auth.isAuthorized,
    anonymousMode: state.user.anonymousMode
});

const mapDispatchToProps = dispatch => ({
    createPartiesVote: dispatch(createPartiesVote),
    fetchPartyVotesList: dispatch(fetchPartyVotesList),
    fetchAveragesVotesList: dispatch(fetchAveragesVotesList),
    fetchRelatedParty: dispatch(fetchRelatedParty),
    addPartyComments: dispatch(addPartyComments),
    fetchPartyCommentList: dispatch(fetchPartyCommentList),
    abuse: payload => dispatch({
        type: ABUSE,
        payload: agent.Abuse.setAbuse(payload)
    }),
});

class PartyDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMyPostsAndComments: '',
            viewMyPostsAndCommentsDefault: '',
            replyMyPostsAndComments: '',
            viewMyVotes: this.props.voteItem && this.props.voteItem.viewMyVotes > 0 ? (parseInt(this.props.voteItem.viewMyVotes) === 1 ? 2 : this.props.voteItem.viewMyVotes) : this.props.currentUser && this.props.currentUser.viewMyVotes,
            viewMyVotesDefault: '',
            prevVote: {personId: '', ability: 0, vision: 0, dateCreated: ''},
            curVote: {personId: props.party.id, ability: 0, vision: 0},
            currentUser: this.props.currentUser,
            privacyModal: false,
            commentBody: '',
            voteItem: '',
            commentList: [],
            currentPolly: {},
            polliesComment: '',
            downVote: 0,
            upVote: 0,
            mayBe: 0,
            vote: '',
            showShare: false,
            isAuthModalOpen: false,
            voterLocation: '',
            isFinal: false,
            reaction: [],
            showCommentErrorMessage: true,
            chars_left: 0,
            chars_leftBody: 0,
            max_char: COMMENT_MAX_CHARACTER,

        };
    }

    componentWillMount() {
        if (this.props.party) {
            const polliesIDs = this.props.party.id
            this.props.fetchPartyVotesList(polliesIDs);
            this.props.fetchRelatedParty(polliesIDs);
            this.props.fetchPartyCommentList(polliesIDs);
            agent.Pollies.searchForTag(this.props.party.name, "party").then(res => {
                if (res && res.length > 0) {
                    let tags = []
                    res.forEach(tag => {
                        tags.push(tag.id)
                    });
                    tags = tags.join(',')
                    agent.Pollies.getNewsList(tags).then(news => {
                        this.setState({
                            newsList: news
                        })
                    })
                }
            })
        }

        agent.Pollies.getAveragesPartyVotes(this.props.party.id).then(res => {
            if (res) {
                this.setState({
                    downVote: res.votesAgainst || 0,
                    upVote: res.votesFor || 0,
                    mayBe: res.votesUnspecified || 0
                })
            }
        }, err => {
            console.log(err.message)
        })

        agent.UserLocations.get().then(res => {
            if (res && res.length) {
                this.setState({
                    voterLocation: res[0] && res[0].id,
                })
            }
        })
    }

    async componentDidMount(prevProps, prevState, snapshot) {
        this.setState({
            reaction: []
        })
        if (this.props.partyCommentsList) {
            this.props.partyCommentsList.map((item) => {
                item.abuse.myAbuse.map((items) => {
                    this.setState(prevState => ({
                        reaction: [
                            ...prevState.reaction,
                            {id: item.id, name: items.abuseType}
                        ]
                    }))
                })
            })
        }
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps !== this.props) && (this.props?.partyCommentsList)) {
            const currentCommentDetail = await (this.props?.partyCommentsList?.length && this.props?.partyCommentsList || []).find(ele => ele.id === this.props?.commentId);
            if (!!currentCommentDetail) {
                const elements = document.querySelector(`[data-id="${this.props?.commentId}"]`);
                const y = elements?.getBoundingClientRect()?.top + window.pageYOffset ;
                if (elements) {
                    window.scrollTo( {behavior: "smooth", top: y - 100  })
                }
            } else {
                if(this.state.showCommentErrorMessage && this.props?.commentId){
                    setTimeout(() => {
                        message.error(getLabel(335));
                    }, 1000);
                }
                this.setState({
                    ...this.state,
                    showCommentErrorMessage: false
                });
            }
        }
    }

    getPartiesVotesById(partyId, partiesVotes) {
        if (partiesVotes.length > 0) {
            return partiesVotes.find(item => item.partyId === partyId && moment(item.dateCreated).isBetween(moment().startOf('day'), moment().endOf('day')));
        }
    }

    componentWillReceiveProps(nextProps) {
        console.log('nextporps',nextProps)
        this.setState({
            reaction: []
        })
        if (this.props.partyCommentsList) {
            this.props.partyCommentsList?.length && this.props.partyCommentsList.map((item) => {
                item.abuse.myAbuse.map((items) => {
                    this.setState(prevState => ({
                        reaction: [
                            ...prevState.reaction,
                            {id: item.id, name: items.abuseType}
                        ]
                    }))
                })
            })
        }

        if (nextProps.partiesVotes) {
            const partiesVoteItem = this.getPartiesVotesById(this.props.party.id, nextProps.partiesVotes);
            const char = partiesVoteItem && partiesVoteItem.comment.length;
            this.setState({chars_left: char || 0})
            this.setState({
                prevVote: partiesVoteItem,
                polliesComment: partiesVoteItem && partiesVoteItem.comment,
                vote: partiesVoteItem && partiesVoteItem.vote,
                isFinal: partiesVoteItem && partiesVoteItem.isFinal
            })
        }

        if (nextProps.partiesVote && nextProps.partiesVote.id) {
            this.setState({
                isVote: nextProps.partiesVote.id
            })
        }

        if (nextProps.partiesVotes && this.state.isVote) {
            const voted = nextProps.partiesVotes.length && nextProps.partiesVotes.find(res => {
                return res.id === this.state.isVote
            });
            if (voted && !this.props.partiesVotesError) {
                this.setState({
                    showShare: true
                })
            }
        }

        const currentUser = this.props.currentUser;
        if (currentUser) {
            this.setState({
                viewMyPostsAndComments: currentUser ? (parseInt(currentUser.viewMyPostsAndComments) === 1 ? 2 : currentUser.viewMyPostsAndComments) : null,
                replyMyPostsAndComments: currentUser ? currentUser.replyMyPostsAndComments : null,
                viewMyVotes: currentUser ? (parseInt(currentUser.viewMyVotes) === 1 ? 2 : currentUser.viewMyVotes) : null,
                viewMyPostsAndCommentsDefault: currentUser ? currentUser.viewMyPostsAndComments : null,
                viewMyVotesDefault: currentUser ? currentUser.viewMyVotes : null,
            })
        }
    }

    onLikeSubmit = (e) => {
        let vote = ''
        if (e.target.name === "downVote") {
            vote = 'A'
        } else if (e.target.name === "upVote") {
            vote = 'F'
        } else if (e.target.name === "mayBe") {
            vote = 'U'
        }
        if (!this.state.voterLocation && this.props.currentUser) {
            this.setState({
                vote, isVoterLocationModal: true,
            })
        } else {
            this.setState({vote, isAuthModalOpen: !this.props.currentUser});
        }
    }

    onChange = (e) => {
        const state = this.state;
        if (  e.target.name === "isFinal") {
            state[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        }else if( e.target.name === "commentBody"){
            const text = e.target.value;
            const textLength = text.length;
            if (textLength <= COMMENT_MAX_CHARACTER) {
            state[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
                state[e.target.name] = e.target.value
                state['chars_leftBody'] = textLength
            }
        }
        else if(e.target.name ==="polliesComment" ){
            console.log("enter")
            const text = e.target.value;
            const textLength = text.length;
            console.log("textLength",textLength)
            if (textLength <= COMMENT_MAX_CHARACTER) {

                state[e.target.name] = e.target.value
                state['chars_left'] = textLength
            }
        } else {
            state[e.target.name] = parseInt(e.target.value);
        }
        this.setState(state);
        if (!this.state.voterLocation && this.props.currentUser) {
            this.setState({
                isVoterLocationModal: true,
            })
        } else {
            this.setState({isAuthModalOpen: !this.props.currentUser});
        }
    }

    handleOnChange = (e, field) => {
        if (!this.state.voterLocation && this.props.currentUser) {
            this.setState({
                isVoterLocationModal: true,
            })
        } else {
            this.setState({
                ...this.state,
                curVote: {...this.state.curVote, [field]: e},
                isAuthModalOpen: !this.props.currentUser
            });
        }
    }

    onCloseAuthModal = () => {
        this.setState({
            isAuthModalOpen: false
        })
    }

    openVotarLocationModel = () => {
        this.setState({
            isVoterLocationModal: false
        })
    }

    voterLocationAdded = () => {
        this.setState({
            isVoterLocationModal: false,
            voterLocation: true
        })
    }

    privacyModal = (val) => {
        this.setState({
            privacyFor: val,
            privacyModal: !this.state.privacyModal,
        })
    }

    onVoteSubmit = () => {
        if (this.state.vote !== '' && this.state.vote !== undefined) {
            const curVote = this.state.curVote;
            curVote.viewMyVotes = this.state.viewMyVotes || 0;
            curVote.isFinal = this.state.isFinal;
            curVote.viewMyVotesDefault = this.state.viewMyVotesDefault || 0;
            curVote.polliesComment = this.state.polliesComment;
            curVote.vote = this.state.vote;
            this.props.createPartiesVote({...curVote}, this.props.party.id);
            this.setState({...this.state, curVote: {...curVote}, show: true});
        } else {
            antdModel.warning({
                title: getLabel(333),
                zIndex: 5000
            });
        }
    }


    onCommentSubmit = () => {
        const currentUser = this.props.currentUser;
        const {commentBody, viewMyPostsAndComments, replyMyPostsAndComments} = this.state
        const commentAdd = {
            "body": commentBody,
            "viewMyPostsAndComments": parseInt(viewMyPostsAndComments || 0),
            "replyMyPostsAndComments": replyMyPostsAndComments || 0,
            "viewMyPostsAndCommentsDefault": currentUser && currentUser.viewMyPostsAndComments,
            "replyMyPostsAndCommentsDefault": currentUser && currentUser.replyMyPostsAndComments,
            "Anonymous": JSON.parse(localStorage.getItem("AnonymousMode"))

        }
        if (commentBody && commentAdd) {
            this.props.addPartyComments(this.props.party.id, commentAdd)
            this.setState({commentBody: ''})
        }

    }

    parseBody = body => {
        return {__html: body};
    }

    onCloseShare = () => {
        this.setState({showShare: false})
    }

    handleDeletePollyComment = async (id) => {
        let formData = new FormData();
        let data = {}
        data.EntityId = id
        data.EntityType = "PartyComment"
        for (const key in data) {
            formData.append(key, data[key]);
        }
        await agent.DeleteComment.deleteComment(formData).then(res => {
            this.props.fetchPartyCommentList(this.props.party.id);
        }).catch(err => console.log('Oh no!', err));
    }

    handleReaction = (name, id, authorID) => {
        const data = this.state.reaction.filter(item => item.id === id && item.name === name)
        if (!data.length) {
            this.setState(prevState => ({
                reaction: [
                    ...prevState.reaction,
                    {id, name}
                ]
            }))
        }
        this.props.abuse({
            "EntityId": id,
            "EntityType": "PartyComment",
            "AbuseType": name,
            "AuthorId": authorID,
        });
    };

    handleReportAbuse = () =>{
        message.error(getLabel(338));
    }
  componentWillReceiveProps(nextProps) {
    const { party } = nextProps
    const staticDescriptionElement = document.getElementById('main-description');
    if (staticDescriptionElement) {
      if(party?.description) {
        staticDescriptionElement.remove();
      }
    }
  }

  componentWillUnmount() {
    const newStaticDescriptionElement = document.createElement('meta');
    newStaticDescriptionElement.id = 'main-description';
    newStaticDescriptionElement.name = 'description';
    newStaticDescriptionElement.content = 'A new social platform dedicated to politics. We\'re taking the good ingredients from the current set of social networks and adding a few new ones to make a unique experience. We\'re just getting started so this is just the beginning.';
    document.head.appendChild(newStaticDescriptionElement);
  }

    render() {
        let privacyArray = [getLabel(71), getLabel(72), getLabel(73), getLabel(78)];
        const {description, name, facebookPage, twitter, youTube, photoName, id, urlSlug} = this.props.party
        const {downVote, upVote, mayBe, vote, polliesComment, showShare, isAuthModalOpen, isFinal, reaction} = this.state
        const {userInfo, anonymousMode} = this.props
        const mayReportAbuse = this.props?.currentUser?.user_privilege?.mayReportAbuse

        return (
          <>
            <Helmet>
            <title>{name}</title>
            <meta name="description" content={(description || '').slice(0,150)}/>
          </Helmet>
            <div className="polly-container">
                {isAuthModalOpen &&
                <UserModal isAuthModalOpen={isAuthModalOpen} onCloseAuthModal={this.onCloseAuthModal}/>}
                {showShare && !this.props.anonymousMode &&
                <SharePostModal showShare={showShare} party={this.props.party} userInfo={this.props.currentUser}
                                onCloseShare={this.onCloseShare}/>}
                {this.state.isVoterLocationModal &&
                <Modal show={this.state.isVoterLocationModal}
                       bsSize="large"
                       className="polly-modal"
                       aria-labelledby="contained-modal-title-lg"
                       onHide={this.openVotarLocationModel}>
                    <div id="votepopup">
                        <div className="modal-header">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3>{getLabel(214)}</h3>
                                </div>
                            </div>
                            <button type="button"
                                    className="close"
                                    onClick={this.openVotarLocationModel}
                                    data-dismiss="modal"
                                    aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <VoterLocationsTab {...this.props} onVoterLocationAdded={this.voterLocationAdded}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>}
                {
                    this.state.privacyModal && this.state.privacyFor === 'viewMyVotes' &&
                    <PrivacyModal
                        onChange={this.onChange}
                        privacyModal={this.privacyModal}
                        selectedAudience={true}
                        viewMyVotes={true}
                        state={this.state}
                    />
                }

                {
                    this.state.privacyModal && this.state.privacyFor === 'viewMyPostsAndComments' &&
                    <PrivacyModal
                        onChange={this.onChange}
                        privacyModal={this.privacyModal}
                        viewMyPostsAndComments={true}
                        selectedAudience={true}
                        state={this.state}
                    />
                }
                <div className="container">
                    <div className={`row politicians-row${anonymousMode ? "-dark cw" : ""}`}>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-4">
                                    <img onError={e => e.target.src = Avatar}
                                         src={photoName ? `/images/parties/${id}/${photoName}` : Avatar} alt={photoName}
                                         className="politicians-vote-img border-radius-10"/>
                                </div>
                                <div className="col-md-8">
                                    <div className="politicians-text-card">
                                        <h1 className={`${anonymousMode ? "cw" : ""}`}>{name}</h1>
                                        <span className="description">{description}</span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="social-share">
                                        {facebookPage &&
                                        <a href={`https://www.facebook.com/${facebookPage}`} target="_blank"
                                           className="fa-icon fa fa-facebook"/>}
                                        {twitter && <a href={`https://twitter.com/${twitter}`} target="_blank"
                                                       className="fa-icon fa fa-twitter"/>}
                                        {youTube && <a href={`https://www.youtube.com/${youTube}`} target="_blank"
                                                       className="fa-icon fa fa-youtube"/>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <h3 className={` m-l-15 handwritten ${anonymousMode ? "cw" : ""}`}>{getLabel(113)}</h3>
                            <div className="bs-callout bs-callout-default">
                                <div className={`row ${anonymousMode ? "bgl cw" : ""}`}>
                                    <div className="col-md-12">
                                        {
                                            this.state.prevVote && this.state.prevVote.dateCreated &&
                                            <VoteItem
                                                title={getLabel(115) + (this.state.prevVote && moment(this.state.prevVote.dateCreated).format('MMMM D, YYYY')) + getLabel(100)}
                                                {...this.state.prevVote}
                                                polliesComment={polliesComment}
                                                disabled={true}
                                                downVote={downVote}
                                                upVote={upVote}
                                                mayBe={mayBe}
                                                vote={vote}
                                                isFinal={isFinal}
                                                isParty={true}
                                                anonymous={this.props.anonymousMode}
                                                charsLeft={this.state.chars_left}
                                                maxChar={this.state.max_char}
                                            />
                                        }
                                        {
                                            !(this.state.prevVote && this.state.prevVote.dateCreated) &&
                                            <VoteItem title={getLabel(101)}
                                                      {...this.state.curVote}
                                                      show={true}
                                                      onAbilityChange={this.handleOnChange}
                                                      onVisionChange={this.handleOnChange}
                                                      onLikeSubmit={this.onLikeSubmit}
                                                      onChange={this.onChange}
                                                      polliesComment={polliesComment}
                                                      downVote={downVote}
                                                      upVote={upVote}
                                                      mayBe={mayBe}
                                                      vote={vote}
                                                      anonymous={this.props.anonymousMode}
                                                      isFinal={isFinal}
                                                      isParty={true}
                                                      charsLeft={this.state.chars_left}
                                                      maxChar={this.state.max_char}
                                            />
                                        }
                                        {
                                            this.state.prevVote && this.state.prevVote.dateCreated &&
                                            <div className="m-t-15">
                                                <b className="m-l-15">{getLabel(116)}</b>
                                            </div>
                                        }
                                    </div>
                                    {
                                        !(this.state.prevVote && this.state.prevVote.dateCreated) && this.props.isAuthorized &&
                                        <div className="row submit-content-party-details">
                                            <div className="col-md-12 m-b-20 ">
                                                <p className="red">{this.props.partiesVotesError}</p>
                                                <div className="pull-right">
                                                    <a onClick={() => this.privacyModal('viewMyVotes')}
                                                       className="small privacylink m-r-20" data-toggle="modal"
                                                       data-target="#privacysettings">
                                                        <i className="mdi mdi-glasses"/>{getLabel(105)}</a>
                                                    <button
                                                        className={`btn smallmargintop text-whitewaves-effect waves-light btn-primary${anonymousMode ? "-dark" : ""}`}
                                                        onClick={this.onVoteSubmit}
                                                        // disabled={this.state.prevVote && this.state.prevVote.dateCreated || !vote}
                                                    >
                                                        {getLabel(106)}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {this.state.prevVote && this.state.prevVote.dateCreated &&
                                    <div className="handwritten" style={{
                                        color: '#ec1c45',
                                        padding: '10px 15px'
                                    }}>{privacyArray[parseInt(this.state.prevVote.viewMyVotes) - 1]}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row subfooter">
                        <div className="col-md-4">
                            <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(118)}</h3>
                                <fieldset className="form-group m-t-5">
                                    <label style={{fontWeight: "unset"}}>{getLabel(273)}</label>
                                    <textarea
                                        className={`form-control${anonymousMode ? "-dark cw" : ""} form-control-lg`}
                                        rows="8"
                                        name="commentBody"
                                        value={this.state.commentBody || ''}
                                        onChange={(e) => this.onChange(e)}
                                        placeholder={getLabel(109)}
                                    />
                                    <span className="max-counter">{this.state.chars_leftBody}/{COMMENT_MAX_CHARACTER}</span>
                                    <hr/>
                                    <div className="float-right">
                                        <a onClick={() => this.privacyModal('viewMyPostsAndComments')}
                                           className="small privacylink m-r-20" data-toggle="modal"
                                           data-target="#privacysettings">
                                            <i className="mdi mdi-glasses"/>{getLabel(105)}
                                        </a>
                                        <button className="btn btn-lg btn-primary float-right"
                                                onClick={this.onCommentSubmit}>{getLabel(106)}</button>
                                    </div>

                                </fieldset>
                                <div className="comments">
                                    {
                                        ((this.props?.partyCommentsList?.length && this.props?.partyCommentsList) || []).map(comment => {
                                            let commentDate = moment(comment.dateCreated).format("YYYY-MM-DD")
                                            return (
                                                <div className="comment" key={comment.id} data-id={comment.id}>
                                                    <header>
                                                        <div className="facebook-reaction col-md-2 fr">
                                        {mayReportAbuse ? <span className="like-btn">
                                            <span
                                                className="like-btn-text">Abuse?</span>
                                                <ul className={`${this.props.anonymousMode ? "reactions-box-dark" : "reactions-box"}`}>
                                                    <span className="reaction reaction-vulgar" onClick={() => {
                                                        this.handleReaction("Vulgar", comment.id, comment.author.id)
                                                    }} data-reaction="Vulgar"/>
                                                    <span className="reaction reaction-irrelevant" onClick={() => {
                                                        this.handleReaction("Irrelevant", comment.id, comment.author.id)
                                                    }} data-reaction="Irrelevant"/>
                                                    <span className="reaction reaction-pointless" onClick={() => {
                                                        this.handleReaction("Pointless", comment.id, comment.author.id)
                                                    }} data-reaction="Pointless"/>
                                                </ul>
                                            </span> : <span className="like-btn-text" onClick={()=>this.handleReportAbuse()}>Abuse?</span>}
                                                            <div className="like-stat">
                                                                <span
                                                                    className="like-emo">{reaction && reaction.map((items) => (items.id === comment.id ?
                                                                    <span
                                                                        className={`like-btn-${items.name || ""}`}/> : ""))}
                                                                </span>
                                                                <span className="like-details">you</span>
                                                            </div>
                                                            <div className="delete-comment">
                                                                {
                                                                    this.props?.currentUser?.roles[0] === "Admin" &&
                                                                    <div style={{
                                                                        marginLeft: 70,
                                                                        clear: 'both',
                                                                        whiteSpace: 'nowrap'
                                                                    }}>
                                                                        <Popconfirm placement="bottomLeft"
                                                                                    title={getLabel(310)}
                                                                                    onConfirm={() => this.handleDeletePollyComment(comment.id)}
                                                                                    okText="Yes" cancelText="No">
                                                                            <div style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                color: "#43c5e6"
                                                                            }}>
                                                                                <i className="fa fa-trash"/>
                                                                            </div>
                                                                        </Popconfirm>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="authorimage">
                                                            {userInfo ?
                                                                <a className="politician">
                                                                    <PostAvatar
                                                                        userName={userInfo[comment.authorId] && userInfo[comment.authorId].userName || ''}
                                                                        isAnonymous={comment.anonymous}/>
                                                                    <span
                                                                        className={`${parseInt(userInfo[comment.authorId]?.gender) === 1 && "female "}${parseInt(userInfo[comment.authorId]?.gender) === 2 && "male"}`}/>
                                                                </a> : <a className="politician">
                                                                    <PostAvatar
                                                                        userName={comment.author && comment.author.userName || ''}
                                                                        isAnonymous={comment.anonymous}/>
                                                                    <span
                                                                        className={`${parseInt(comment.author && comment.author.gender) === 1 && "female "}${parseInt(comment.author && comment.author.gender) === 2 && "male"}`}/>
                                                                </a>}
                                                        </div>
                                                        <div className="articletitle">
                                                            {
                                                                userInfo ? <div className="author">
                                                                    {userInfo[comment.authorId] &&
                                                                    (comment.anonymous ?
                                                                        <Link to="">{getLabel(284)}</Link> : <Link
                                                                            to={`/@${userInfo[comment.authorId].userName}`}>
                                                                            {userInfo[comment.authorId].displayName}, {userInfo[comment.authorId].displayLocation}
                                                                        </Link>)}
                                                                </div> : <div className="author">
                                                                    {comment.anonymous ? <a>{getLabel(284)}</a> :
                                                                        <a>{comment.author && comment.author.displayName || "User"}, {comment.author && comment.author.displayLocation}</a>}
                                                                </div>
                                                            }
                                                            <div
                                                                className="date m-0">{comment.dateCreated && new Date(comment.dateCreated).toDateString() + " " + new Date(comment.dateCreated).toLocaleTimeString('en-US')}</div>
                                                            <div className="row">
                                                                <div className="col-sm-10">
                                                                    <div className="mainpolinfo">
                                                                        <div className="polscores">
                                                                            {
                                                                                comment.vision >= 0 && comment.vision !== null &&
                                                                                <div className="row">
                                                                                    <div
                                                                                        className="col-md-3 vote-col-name"
                                                                                        style={{paddingLeft: 0}}>
                                                                                        <span>{getLabel(111)}</span>
                                                                                    </div>
                                                                                    <div className="col-md-7 vision">
                                                                                        <Slider min={0}
                                                                                                max={10}
                                                                                                value={comment.vision}
                                                                                                orientation="horizontal"
                                                                                        />
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-2 vote-col-name">
                                                                                        <span
                                                                                            className="result">{comment.vision}</span>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {
                                                                                comment.ability >= 0 && comment.ability !== null &&
                                                                                <div className="row">
                                                                                    <div
                                                                                        className="col-md-3 vote-col-name"
                                                                                        style={{paddingLeft: 0}}
                                                                                        authorimage>
                                                                                        <span>{getLabel(110)}</span>
                                                                                    </div>
                                                                                    <div className="col-md-7 ability">
                                                                                        <Slider min={0}
                                                                                                max={10}
                                                                                                value={comment.ability}
                                                                                                orientation="horizontal"
                                                                                        />
                                                                                    </div>
                                                                                    <div
                                                                                        className="col-md-2 vote-col-name">
                                                                                        <span
                                                                                            className="result">{comment.ability}</span>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    comment.vote &&
                                                                    <div className="col-sm-2">
                                                                        {comment.vote === "F" &&
                                                                        <img src={up_vote} width="40" height="40"
                                                                             alt="upVote"/>}
                                                                        {comment.vote === "U" &&
                                                                        <img src={undecided_vote} width="40" height="40"
                                                                             alt="unDecidedVote"/>}
                                                                        {comment.vote === "A" &&
                                                                        <img src={down_vote} width="40" height="40"
                                                                             alt="downVote"/>}
                                                                    </div>
                                                                }
                                                                <div className="col-sm-12" style={{padding: '5px 5px'}}>
                                                                    <Link
                                                                        to={`/vote/${urlSlug}/${comment.author && comment.author.userName}/${commentDate}`}>
                                                                        {comment.body}
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </header>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(121)}</h3>
                                <div className="comments inthenews">
                                    {(this.state.newsList || []).map((item, i) => {
                                        return (
                                            <div key={i} className="comment pointer">
                                                <Link to={`/posts/${item.slug}`}>
                                                    <header>
                                                        <div className="authorimage">
                                                            <a>{item && <PostAvatar
                                                                userName={item.authorUserName || item.author && item.author.userName || ''}/>}</a>
                                                        </div>
                                                        <div className="articletitle">
                                                            <div className="text">
                                                                <a style={{color: '#000000', fontWeight: 'lighter'}}>
                                                                    <div style={{fontSize: 13}}
                                                                         dangerouslySetInnerHTML={this.parseBody(item.body)}/>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </header>
                                                </Link>
                                                <div className="date hidden">{getLabel(122)}</div>
                                            </div>
                                        )
                                    })
                                    }
                                    {
                                        (this.state.newsList || []).length === 0 &&
                                        <div>{getLabel(123)}</div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            <div className={`politiqbox${anonymousMode ? "-dark cw" : ""}`}>
                                <h3 className={`${anonymousMode ? "cw" : ""}`}>{getLabel(124)}</h3>
                                <ul>
                                    {
                                        (this.props.relatedPartyList?.length && this.props.relatedPartyList || []).map((item, i) => {
                                            return (
                                                <li key={i}>
                                                    <a href="#" className="politician">
                                                        <img onError={e => e.target.src = Avatar}
                                                             src={item.photoName ? `/images/people/${item.personID}/official/${item.photoName}` : Avatar}
                                                             alt="" width="128" height="128" className="img-circle"/>
                                                        <span className="poli-info">
                                                            <span
                                                                className={`${parseInt(item.gender) === 1 && "female "}${parseInt(item.gender) === 2 && "male"}`}/>
                                                            <span className="poliname">
                                                                <a href={`/${item.urlSlug}`}
                                                                   target="_blank">{item.displayName}</a>
                                                            </span>
                                                            <span
                                                                className={`occupation ${anonymousMode ? "cw" : ""}`}>{item.lastOfficeTitle}</span>
                                                            <span
                                                                className="country">{item.lastOfficeCountryName}</span>
                                                        </span>
                                                    </a>
                                                </li>
                                            );
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PartyDetails);
